import { render, staticRenderFns } from "./fieldManageItem.vue?vue&type=template&id=f4edd7fa&scoped=true"
import script from "./fieldManageItem.vue?vue&type=script&lang=js"
export * from "./fieldManageItem.vue?vue&type=script&lang=js"
import style0 from "./fieldManageItem.vue?vue&type=style&index=0&id=f4edd7fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4edd7fa",
  null
  
)

export default component.exports